import { useFeedbackStore } from '../../state/feedback.ts';

export function ErrorFeedback() {
  const { error, dismiss } = useFeedbackStore();
  if (!error) return null;
  return (
    <div role="alert" className="fixed bottom-12 start-4 end-4 z-50 mx-auto flex max-w-xl items-center gap-3 rounded-xl border border-rose-300 bg-rose-50 p-4 text-sm text-rose-900 shadow-lg dark:border-rose-800 dark:bg-rose-950 dark:text-rose-100">
      <div className="min-w-0 flex-1"><p className="font-semibold">הפעולה נכשלה. נסו שוב.</p><p className="break-words" dir="auto">{error}</p></div>
      <button type="button" onClick={dismiss} className="rounded px-2 py-1" aria-label="סגירת הודעת שגיאה">סגור</button>
    </div>
  );
}
